export default {
  meta: {
    title: '门店管理列表配置',
    // url: '/system/enterprise', // 埋点用，记录所属模块
  },
};
